var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "labor-tpl" }, [
    _c("form", [
      _c("div", { staticClass: "syspage" }, [
        _c("h1", { staticClass: "text-center" }, [_vm._v("劳动合同书")]),
        _c("h4", { staticClass: "text-right" }, [
          _vm._v("编号："),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.contractNo,
                expression: "form.contractNo"
              }
            ],
            staticClass: "contract-no",
            attrs: { name: "contractNo" },
            domProps: { value: _vm.form.contractNo },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "contractNo", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "signerblock" }, [
          _c("h4", [_vm._v("甲方（用人单位）")]),
          _c("h4", [
            _c("span", [_vm._v("单位名称")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.companyName,
                  expression: "form.companyName"
                }
              ],
              staticClass: "company-name",
              attrs: { name: "companyName" },
              domProps: { value: _vm.form.companyName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "companyName", $event.target.value)
                }
              }
            })
          ]),
          _c("h4", [
            _c("span", [_vm._v("法定代表人")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.companyLegal,
                  expression: "form.companyLegal"
                }
              ],
              staticClass: "company-legal",
              attrs: { name: "companyLegal" },
              domProps: { value: _vm.form.companyLegal },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "companyLegal", $event.target.value)
                }
              }
            })
          ]),
          _c("h4", [
            _c("span", [_vm._v("单位地址")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.companyAddress,
                  expression: "form.companyAddress"
                }
              ],
              staticClass: "company-address",
              attrs: { name: "companyAddress" },
              domProps: { value: _vm.form.companyAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "companyAddress", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "signerblock" }, [
          _c("h4", [_vm._v("乙方（劳动者）")]),
          _c("h4", [
            _c("span", [_vm._v("姓名")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.laborName,
                  expression: "form.laborName"
                }
              ],
              staticClass: "labor-name",
              attrs: { name: "laborName" },
              domProps: { value: _vm.form.laborName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "laborName", $event.target.value)
                }
              }
            })
          ]),
          _c("h4", [
            _c("span", [_vm._v("性别")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.laborGender,
                  expression: "form.laborGender"
                }
              ],
              staticClass: "labor-gender",
              attrs: { name: "laborGender" },
              domProps: { value: _vm.form.laborGender },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "laborGender", $event.target.value)
                }
              }
            })
          ]),
          _c("h4", [
            _c("span", [_vm._v("身份证号码")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.laborIdentityNo,
                  expression: "form.laborIdentityNo"
                }
              ],
              staticClass: "labor-indetity",
              attrs: { name: "laborIdentityNo" },
              domProps: { value: _vm.form.laborIdentityNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "laborIdentityNo", $event.target.value)
                }
              }
            })
          ]),
          _c("h4", [
            _c("span", [_vm._v("家庭住址")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.laborAddress,
                  expression: "form.laborAddress"
                }
              ],
              staticClass: "labor-address",
              attrs: { name: "laborAddress" },
              domProps: { value: _vm.form.laborAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "laborAddress", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        根据《中华人民共和国劳动法》、《劳动合同法》等法律法规的规定，\n        "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.firstParty,
                expression: "form.firstParty"
              }
            ],
            attrs: { name: "firstParty" },
            domProps: { value: _vm.form.firstParty },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "firstParty", $event.target.value)
              }
            }
          }),
          _vm._v("（以下简称甲方）与"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.secondParty,
                expression: "form.secondParty"
              }
            ],
            attrs: { name: "secondParty" },
            domProps: { value: _vm.form.secondParty },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "secondParty", $event.target.value)
              }
            }
          }),
          _vm._v(
            "\n        （以下简称乙方）按照平等自愿的原则，经协商一致，达成以下协议，以兹共同遵守。\n      "
          )
        ]),
        _vm._m(0),
        _c("h5", [_vm._v("二、劳动合同期限")]),
        _c(
          "p",
          [
            _vm._v("\n        （一） 有固定期限：自\n        "),
            _c("el-date-picker", {
              attrs: { type: "date", placeholder: "选择日期" },
              model: {
                value: _vm.form.limitStartYear,
                callback: function($$v) {
                  _vm.$set(_vm.form, "limitStartYear", $$v)
                },
                expression: "form.limitStartYear"
              }
            }),
            _vm._v("\n        始至  "),
            _c("el-date-picker", {
              attrs: { type: "date", placeholder: "选择日期" },
              model: {
                value: _vm.form.limitEndYear,
                callback: function($$v) {
                  _vm.$set(_vm.form, "limitEndYear", $$v)
                },
                expression: "form.limitEndYear"
              }
            }),
            _vm._v("止。"),
            _c("br"),
            _vm._v("\n        其中，试用期自"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.probationYearS,
                  expression: "form.probationYearS"
                }
              ],
              attrs: { name: "probationYearS" },
              domProps: { value: _vm.form.probationYearS },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "probationYearS", $event.target.value)
                }
              }
            }),
            _vm._v("\n        日始至"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.probationYearE,
                  expression: "form.probationYearE"
                }
              ],
              attrs: { name: "probationYearE" },
              domProps: { value: _vm.form.probationYearE },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "probationYearE", $event.target.value)
                }
              }
            }),
            _vm._v(
              "止。\n        在此基础之上，根据乙方试用期表现，经甲方综合评价及事实证明，以及乙方同意，可酌情缩短或延长试用期限，缩短或延长时间最长不超过一个月。\n      "
            )
          ],
          1
        ),
        _vm._m(1),
        _vm._m(2),
        _c("h5", [_vm._v("三、工作内容")]),
        _c("p", [
          _vm._v(
            "\n        （一）在双方签订本合同时，甲方组织乙方进行对甲方规章制度（包括但不限于《员工手册》、甲方行政、人事、财务、各部门制度等）的学习讨论，\n        甲方充分履行了告知的义务，乙方对此予以确认并表示遵守。\n        甲乙双方一致确认，甲方的规章制度为本合同的组成部分。\n      "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n        （二）经甲方招聘，充分向乙方说明甲方招聘的工作性质、工作内容、工作条件、工作环境、劳动时间、职业危害、安全生产状况、劳动报酬等本合同所涉及的全部内容后，\n        乙方同意按照甲方工作需要在"
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.job,
                expression: "form.job"
              }
            ],
            attrs: { name: "job" },
            domProps: { value: _vm.form.job },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "job", $event.target.value)
              }
            }
          }),
          _vm._v(" 岗位工作，具体工作内容和要求是：\n      ")
        ]),
        _vm._m(3),
        _c("p", [
          _vm._v(
            "（三）因生产经营变化和工作需要，经双方协商一致，甲方可以调整乙方的工作岗位和工作内容。在本合同有效期限内，双方不需另行签订劳动合同。"
          )
        ]),
        _c("h5", [_vm._v("四、工作时间和休息休假")]),
        _c("p", [_vm._v("（一）甲方执行法律规定的工时制度和休息休假制度。")]),
        _c("p", [
          _vm._v(
            "（二）甲方由于工作需要并与乙方协商后，或出现法律、行政法规规定的其他情形的，可以延长工作时间。甲方组织对乙方的培训时间，不属工作时间或延长工作时间。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（三）甲方对乙方延长的工作时间可安排同等时间调休；甲方在给乙方发放的绩效奖励中同时已包含了对乙方延长工作时间的补偿。"
          )
        ]),
        _c("h5", [_vm._v("五、劳动报酬")]),
        _c("p", [
          _vm._v(
            "（一）甲方根据法律法规的规定，结合单位实际和按劳分配原则，自主确定工资分配形式和工资水平。"
          )
        ]),
        _c("p", [
          _vm._v(
            "\n        （二）甲方根据其生产经营特点和乙方的岗位，确定对乙方实行基本工资+岗位（职务）津贴+浮动工资的分配形式。\n        其中，乙方试用期月工资为人民币¥"
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.probationSalary,
                expression: "form.probationSalary"
              }
            ],
            attrs: { name: "probationSalary" },
            domProps: { value: _vm.form.probationSalary },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "probationSalary", $event.target.value)
              }
            }
          }),
          _vm._v("元。\n        试用期满，基本工资为人民币¥ "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.baseSalary,
                expression: "form.baseSalary"
              }
            ],
            attrs: { name: "baseSalary" },
            domProps: { value: _vm.form.baseSalary },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "baseSalary", $event.target.value)
              }
            }
          }),
          _vm._v("元，岗位（职务）津贴人民币¥"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.allowance,
                expression: "form.allowance"
              }
            ],
            attrs: { name: "allowance" },
            domProps: { value: _vm.form.allowance },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "allowance", $event.target.value)
              }
            }
          }),
          _vm._v(
            "元。\n        浮动工资按照甲方的规章制度、乙方业绩、甲方经营情况等确定。\n        乙方同意，乙方每月固定工资中的10%为甲方向乙方支付的乙方承担保密义务和竞业限制义务的津贴。\n      "
          )
        ]),
        _c("p", [
          _vm._v(
            "（三）随着乙方技术水平、劳动态度、工作绩效等的变化，乙方的劳动报酬可作相应调整。具体调整办法按照甲方的规章制度执行。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（四）甲方应以货币形式按月支付乙方的劳动报酬。具体发放时间按照甲方相关规定执行。"
          )
        ]),
        _c("h5", [_vm._v("六、劳动保护和劳动条件")]),
        _c("p", [
          _vm._v(
            "（一）甲、乙双方执行国家劳动安全卫生法律、法规、规程和标准，甲方对乙方进行劳动安全卫生教育、防止事故、减少职业危害。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（二）甲方为乙方提供符合国家规定的劳动安全卫生条件和必要的劳动安全防护用品，努力改善劳动条件。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（三）乙方在劳动过程中应严格遵守安全操作规律，对甲方违章指挥、强行冒险作业，有权拒绝执行。对危害生命安全的行为，有权批评、检举和控告。"
          )
        ]),
        _c("h5", [_vm._v("七、社会保险和福利")]),
        _c("p", [
          _vm._v(
            "\n        （一）甲方按照国家有关基本社会保险的规定为乙方办理基本社会保险，乙方的基本社会保险按不低于当地政府公布的上年度社会平均工资下线计算缴纳保险费。\n        具体按甲方的有关社会保险的规定执行。\n      "
          )
        ]),
        _c("p", [
          _vm._v(
            "（二）基本社会保险费由甲乙双方按法律法规规定分别承担。由乙方承担的部分，乙方同意甲方在其劳动报酬中扣除。"
          )
        ]),
        _c("p", [
          _vm._v("（三）甲方努力创造条件，改善集体福利，提高乙方的福利待遇。")
        ]),
        _c("h5", [_vm._v("八、规章制度及违反规章制度的处罚")]),
        _c("p", [_vm._v("（一）甲方依法建立和完善本企业规章制度。")]),
        _c("p", [
          _vm._v(
            "（二）甲乙双方必须遵守法律、法规、甲方的规章制度及按各阶段工作计划。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（三）甲方有权根据法律、法规、甲方的规章制度、甲方规定的工作指标、指令以及按各阶段工作计划对乙方进行奖惩。"
          )
        ]),
        _c("h5", [_vm._v("九、劳动合同的变更、解除终止")]),
        _c("p", [
          _vm._v(
            "（一）劳动合同的变更、解除、终止按法律规定以及甲方的规章制度及各阶段工作计划与本合同约定执行。"
          )
        ]),
        _c("p", [
          _vm._v("（二）有下列情形之一的，乙方可随时通知甲方解除合同：")
        ]),
        _vm._m(4),
        _c("p", [_vm._v("（三）有下列情形之一的，乙方不得提出解除合同：")]),
        _vm._m(5),
        _c("p", [
          _vm._v("（四）乙方有下列情形之一的，甲方可以与乙方解除劳动关系：")
        ]),
        _vm._m(6),
        _c("h5", [_vm._v("十、甲乙双方协商约定的其他内容")]),
        _c("p", [
          _vm._v(
            "\n        （一）乙方在合同期内接受甲方任务或者利用甲方的物资技术条件所作出的作品和发明创造及其相关权利，包括但不限于专利、专有技术、软件作品等均属于职务成果，知识产权全部归甲方所有。\n      "
          )
        ]),
        _c("p", [
          _vm._v(
            "（二）乙方应将属于职务成果的知识产权的所有资料交甲方保存，不得将其提供给任何其他单位或个人。"
          )
        ]),
        _c("p", [_vm._v("（三）保密条款：")]),
        _vm._m(7),
        _c("p", [_vm._v("（四）竞业限制：")]),
        _vm._m(8),
        _c("h5", [_vm._v("十一、违反劳动合同的责任")]),
        _c("p", [
          _vm._v(
            "（一）甲方在本合同期满前擅自解除劳动合同，按法律规定承担违约责任。"
          )
        ]),
        _c("p", [
          _vm._v(
            "\n        （二）乙方保证向甲方提供的所有有关信息（包括乙方入职表中的全部信息）、文凭、资料、资质证书、学术成果等证明文件均真实有效。\n        双方约定，如乙方提供的相关信息、证明文件和资料有任何虚假成分，由乙方承担全部责任，甲方可随时解除本劳动合同并不予支付任何经济补偿。\n      "
          )
        ]),
        _c("p", [
          _vm._v(
            "（三）乙方因违反操作或作业规范，给客户或甲方造成经济损失的，甲方有权要求乙方赔偿，并按规定予以处理。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（四）在本合同期满前乙方因故离职，需向公司提前30天提出申请，经同意后办理离职手续。"
          )
        ]),
        _c("p", [
          _vm._v(
            "（五）与甲方订立有培训合同未履行完毕的，乙方应按培训合同约定进行赔偿。"
          )
        ]),
        _c("p", [
          _vm._v(
            "\n        （六）乙方违反知识产权、保密条款及竞业限制的有关规定，若能确定甲方损失的，\n        由乙方承担全部损失。若甲方实际损失超过违约金，按照实际损失赔偿。除直接损失外，\n        违约赔偿还包括但不限于：\n      "
          )
        ]),
        _vm._m(9),
        _c("p", [
          _vm._v(
            "\n        （七）乙方因合同终止或合同解除离开公司前，应向甲方交回甲方的所有技术、商业资料，\n        应到财务部门、行政部门、人力资源部门完清一切手续，办好工作交接，否则给甲方造成损失的，\n        应由乙方赔偿，甲方有权不给予经济补偿。\n      "
          )
        ]),
        _c("h5", [_vm._v("十二、劳动争议的处理")]),
        _c("p", [
          _vm._v(
            "甲乙双方因履行劳动合同发生争议，应友好协商解决，协商不成可依法通过提起劳动仲裁和诉讼解决。"
          )
        ]),
        _c("h5", [_vm._v("十三、其他")]),
        _vm._m(10),
        _c("ul", { staticClass: "sys-list-signer" }, [
          _c("li", [
            _vm._v("甲方（盖章）："),
            _c("br"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpSignYear,
                  expression: "form.fpSignYear"
                }
              ],
              attrs: { name: "fpSignYear" },
              domProps: { value: _vm.form.fpSignYear },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpSignYear", $event.target.value)
                }
              }
            })
          ]),
          _c("li", [
            _vm._v("乙方（签字）："),
            _c("br"),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spSignYear,
                  expression: "form.spSignYear"
                }
              ],
              attrs: { name: "spSignYear" },
              domProps: { value: _vm.form.spSignYear },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spSignYear", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("input", {
          attrs: { type: "hidden", value: "labor", name: "tempType" }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "list-table" }, [
      _c("li", [_vm._v("一、")]),
      _c("li", [
        _vm._v(
          "\n          乙方确保与甲方签订本劳动合同时未与其他用人单位存在任何劳动关系或发生劳动争议。乙方承诺，如有类似情况发生，本劳动合同无效，由乙方承担相应的一切责任。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("（二） 无固定期限：自"),
      _c("span", [_vm._v("/")]),
      _vm._v("年"),
      _c("span", [_vm._v("/")]),
      _vm._v("月"),
      _c("span", [_vm._v("/")]),
      _vm._v(
        "日始至甲乙双方约定的劳动合同终止条件和法定的合同终止条件出现时止。"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("（三）以完成一定的工作为期限：自"),
      _c("span", [_vm._v("/")]),
      _vm._v("年"),
      _c("span", [_vm._v("/")]),
      _vm._v("月"),
      _c("span", [_vm._v("/")]),
      _vm._v(" 日始至"),
      _c("span", [_vm._v("/")]),
      _vm._v("工作完成之日止")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "按本岗位工作职责（详见岗位说明书）、年度目标责任书和甲方制定的规章制度之要求保质保量完成工作任务。"
        )
      ]),
      _c("li", [_vm._v("遵守甲方的各项规章制度。")]),
      _c("li", [
        _vm._v("每年按甲方规定的标准进行年度工作业绩的考评，并据此进行奖惩。")
      ]),
      _c("li", [_vm._v("接受甲方对日常工作的安排、指示及工作业绩的考评。")]),
      _c("li", [_vm._v("完成甲方安排的临时性工作任务。")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [_vm._v("在试用期内的；")]),
      _c("li", [
        _vm._v("甲方以暴力威胁或者非法限制人身自由的手段强迫劳动的；")
      ]),
      _c("li", [
        _vm._v(
          "\n          甲方未按照本合同约定及时足额支付劳动报酬或者提供劳动条件的。\n          此处“及时”指的是：在依法履行劳动合同的前提下，甲方按本合同约定或相关法律、法规的规定，向乙方足额支付劳动报酬，\n          如遇乙方违反劳动合同、劳动纪律，或遇不可抗力、节假日顺延支付等情况，不视为“未及时”。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "正在参与甲方重要科研或开发项目、重大技术改造项目、所承担的工作任务尚未完成的；"
        )
      ]),
      _c("li", [
        _vm._v("与甲方签订有培训合同，培训合同所约定的乙方服务期尚未届满的；")
      ]),
      _c("li", [
        _vm._v(
          "违反法律、法规、甲方的规章制度、各阶段工作计划相关约定，正在接受企业审查、审计尚未做出结论的；"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [_vm._v("在试用期内被证明不符合录用条件的；")]),
      _c("li", [
        _vm._v("\n          严重违反甲方的规章制度的；\n          "),
        _c("ol", [
          _c("li", [
            _vm._v(
              "\n              甲乙双方在此确认：如下所涉内容均系甲方的重大“规章制度”，出现如下情形之一，\n              即构成乙方“严重违反甲方的规章制度”除甲方有权随时解除劳动合同、乙方无权获得任何经济补偿金之外，\n              乙方并需乙方在签订本合同前，并未终止与其他雇主订立的所有劳动合同以及其他聘用合同；\n              或乙方在本合同有效期间同时受聘于两个或两个以上雇主。\n            "
            )
          ]),
          _c("li", [
            _vm._v(
              "\n              乙方在签订本合同后，甲方发现乙方有隐瞒、造假、虚报或与事实不符等情况（包括但不限于教育、学历、工作经历、身体状况等）。\n            "
            )
          ]),
          _c("li", [
            _vm._v(
              "依法未能保守甲方的商业机密。乙方应当遵守甲方的保密制度，应对所有与甲方有关的信息（包括但不限于财务、客户、产品、技术、销售等信息）予以保密。"
            )
          ])
        ])
      ]),
      _c("li", [_vm._v("严重违反甲方规定的工作指令和各阶段工作计划；")]),
      _c("li", [_vm._v("严重失职，营私舞弊，给甲方利益造成重大损害的；")]),
      _c("li", [_vm._v("违反法律、法规，被处以刑事、行政处罚的；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "\n          甲方所有的科研成果、专利、专有技术、软件、核心技术、技术资料、\n          营销网络、客户信息和资料、人事信息和资料、财务信息和资料、涉及营销方面的文件、方法、\n          信息以及甲方的其他商业秘密均属保密内容\n          。"
        )
      ]),
      _c("li", [
        _vm._v(
          "\n          乙方有保守上述第1条全部保密内容的义务，以及保密信息安全相关规定的保密义务，不得外泄，无工作需要不得刺探，不得外传。\n        "
        )
      ]),
      _c("li", [
        _vm._v(
          "乙方若有违反，甲方有权予以无经济补偿解除劳动关系处理，要求乙方赔偿甲方全部损失，并依法追究乙方其他法律责任。"
        )
      ]),
      _c("li", [
        _vm._v(
          "乙方对甲方及甲方所持甲方合作方的商业秘密，保密期不因本合同的终止、解除而终止，保密期直至相关商业秘密、技术秘密由甲方或甲方合作方自行公开为止。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "\n          在合同期内，未经甲方书面允许，乙方不得自营与甲方同行业或有竞争关系的产品或服务；\n          乙方不得在甲方之外从事兼职工作（包括有偿和无偿兼职），也不得对与甲方同行业或类似或有竞争关系的企业和其他组织或机构提供技术、产品、营销、财务、管理等咨询或指导。\n          未经甲方书面同意，乙方不得利用甲方的知识产权、核心技术进行新的研究与研发，乙方若有违反，甲方有权予以除名处理并要求乙方承担全部法律责任，赔偿甲方的全部损失。\n        "
        )
      ]),
      _c("li", [
        _vm._v(
          "\n          在合同解除后，甲方认为乙方有竟业禁止必要的，有权与乙方另行签订《竟业禁止协议》，协议内容依照《劳动合同法》等有关法律另行商议订立。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [_vm._v("甲方招录乙方的相关费用；")]),
      _c("li", [_vm._v("培训费用；")]),
      _c("li", [_vm._v("乙方因违约或侵权所得收益；")]),
      _c("li", [
        _vm._v("因商业秘密被公开造成损失的，以该商业秘密的全部价值计算。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "甲方有关规章制度包括但不限于《员工手册》、甲方行政、人事、财务、各部门制度等）作为本合同的附件与本合同有同等效力。"
        )
      ]),
      _c("li", [
        _vm._v(
          "甲乙双方签订的《员工保密协议》作为本合同附件与本合同有同等法律效力。"
        )
      ]),
      _c("li", [_vm._v("本合同一式叁份，甲方两份，乙方壹份，均具同等效力。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbb22224", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbb22224","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/labor.vue
// module id = yWzL
// module chunks = 57